import { render, staticRenderFns } from "./RegisterSettingEditor.modal.vue?vue&type=template&id=247fcf39&scoped=true&"
import script from "./RegisterSettingEditor.modal.vue?vue&type=script&lang=js&"
export * from "./RegisterSettingEditor.modal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSettingEditor.modal.vue?vue&type=style&index=0&id=247fcf39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fcf39",
  null
  
)

export default component.exports